export enum RouterOrigins {
    NEW_GALLERY_PAGE = '3',
    NEW_MANAGE_TEMPLATES = '1',
    OLD_BRAND = '0',
    OLD_TEMPLATE_GALLERY = '2',
    /*
     * If changing this value (SET_PASSWORD), you must also change it in MvResetPasswordCtrl.
     * Until we're fully away from the legacy set password page.
     */
    SET_PASSWORD = '4',
}
